export enum ProgramArchiveOption {
    ArchiveAll = 'archive_all',
    ArchiveOnlyProgram = 'archive_only_program',
}
